export interface Movie {
  id: string;
  title: string;
  typeLabel: "电影" | "电视剧";
  genres: string[];
  region: string;
  year: number;
  rating: number;
  views: number;
  duration: string;
  director: string;
  actors: string[];
  synopsis: string;
  cover: string;
  backdrop: string;
  episodes?: number;
  tags: string[];
  featured?: boolean;
}

export interface CategoryItem {
  key: string;
  label: string;
  desc: string;
  icon: string;
}

export const categories: CategoryItem[] = [
  { key: "film", label: "电影", desc: "院线热映与经典佳片，涵盖动作、科幻、悬疑等多元类型", icon: "ri-film-line" },
  { key: "tv", label: "电视剧", desc: "正在热播与完结好剧，一次追到结局", icon: "ri-tv-2-line" },
  { key: "guochan", label: "国产剧", desc: "国产高分剧集，都市、古装、悬疑一网打尽", icon: "ri-building-2-line" },
  { key: "oumei", label: "欧美剧", desc: "英美精品剧集，宏大制作与精彩叙事", icon: "ri-earth-line" },
  { key: "hanju", label: "韩剧", desc: "韩式浪漫与悬疑佳作，追剧不迷路", icon: "ri-heart-3-line" },
  { key: "riju", label: "日剧", desc: "日系温情与热血故事，细腻治愈", icon: "ri-sun-line" },
  { key: "dongman", label: "动漫", desc: "热血奇幻动画作品，画面与剧情俱佳", icon: "ri-magic-line" },
];

export const genreOptions = [
  "动作", "科幻", "悬疑", "爱情", "喜剧", "剧情", "犯罪", "奇幻", "冒险", "古装", "惊悚", "青春", "历史", "战争", "医疗", "权谋", "推理",
];

export const regionOptions = ["中国大陆", "美国", "英国", "韩国", "日本", "中国香港"];

export const yearOptions = ["2026", "2025", "2024", "2023"];

export const movies: Movie[] = [
  {
    id: "d1",
    title: "星际迷航：黎明边缘",
    typeLabel: "电影",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.7,
    views: 1280,
    duration: "142分钟",
    director: "艾伦·卡特",
    actors: ["迈克尔·雷诺", "艾玛·斯通菲尔德", "路易斯·陈"],
    synopsis: "一支远征舰队在探测未知星域时意外落入时间裂隙，船员们必须在黎明到来前找到回家的坐标。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20before%20a%20glowing%20deep%20blue%20nebula%2C%20dramatic%20rim%20lighting%2C%20dark%20moody%20space%20background%2C%20epic%20atmosphere%2C%20high%20detail%2C%20film%20grain%2C%20no%20text&width=400&height=600&seq=pp-d1-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sleek%20spaceship%20floating%20near%20a%20giant%20blue%20planet%2C%20dramatic%20rim%20light%2C%20deep%20space%20starry%20background%2C%20moody%20sci-fi%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d1-backdrop&orientation=landscape",
    tags: [],
    featured: true,
  },
  {
    id: "d2",
    title: "暗夜缉凶",
    typeLabel: "电影",
    genres: ["犯罪", "悬疑"],
    region: "中国大陆",
    year: 2024,
    rating: 8.4,
    views: 980,
    duration: "126分钟",
    director: "周云鹏",
    actors: ["张铭远", "李蔓", "王志坚"],
    synopsis: "一桩尘封十年的旧案重见天日，刑警队长在雨夜的都市里追查真凶，却发现真相远比想象更复杂。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%2C%20detective%20in%20a%20rain%20soaked%20city%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20tense%20dark%20mood%2C%20orange%20streetlight%20glow%2C%20high%20detail%2C%20film%20noir%2C%20no%20text&width=400&height=600&seq=pp-d2-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20rainy%20city%20street%20at%20night%20with%20glowing%20neon%20signs%20and%20wet%20reflective%20road%2C%20lone%20silhouette%20walking%20away%2C%20moody%20crime%20thriller%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d2-backdrop&orientation=landscape",
    tags: [],
    featured: true,
  },
  {
    id: "d3",
    title: "长安幻夜录",
    typeLabel: "电影",
    genres: ["古装", "动作"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    views: 1105,
    duration: "134分钟",
    director: "顾长亭",
    actors: ["苏景行", "白灵", "秦无殇"],
    synopsis: "盛唐长安一夜风云突变，无名剑客卷入朝堂阴谋，用一身武艺守护城池与真相。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20wuxia%20movie%20poster%2C%20swordsman%20in%20flowing%20robe%20on%20a%20lantern%20lit%20palace%20rooftop%2C%20warm%20amber%20glow%2C%20dark%20night%20background%2C%20epic%20elegant%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d3-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20ancient%20chinese%20palace%20city%20at%20night%20with%20hundreds%20of%20glowing%20lanterns%2C%20misty%20atmosphere%2C%20warm%20amber%20light%2C%20epic%20historical%20scene%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d3-backdrop&orientation=landscape",
    tags: [],
    featured: true,
  },
  {
    id: "d4",
    title: "深海回响",
    typeLabel: "电影",
    genres: ["科幻", "惊悚"],
    region: "英国",
    year: 2025,
    rating: 7.9,
    views: 860,
    duration: "118分钟",
    director: "奥利弗·海耶斯",
    actors: ["凯特·莫里森", "丹尼尔·沃克"],
    synopsis: "深海科考站与外界失联，队员们追踪一段神秘声呐信号，却在海底遇见了不该存在的东西。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20deep%20sea%20thriller%20poster%2C%20diver%20lantern%20beam%20cutting%20through%20dark%20ocean%20water%2C%20eerie%20cold%20blue%20tones%2C%20suspended%20particles%2C%20tense%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d4-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20underwater%20deep%20sea%20scene%2C%20shaft%20of%20light%20penetrating%20dark%20water%2C%20mysterious%20eerie%20mood%2C%20cold%20blue%20tones%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d4-backdrop&orientation=landscape",
    tags: [],
    featured: true,
  },
  {
    id: "d5",
    title: "城市之光",
    typeLabel: "电影",
    genres: ["剧情", "爱情"],
    region: "中国香港",
    year: 2023,
    rating: 8.3,
    views: 1020,
    duration: "121分钟",
    director: "陈可仪",
    actors: ["梁嘉然", "何韵"],
    synopsis: "在霓虹闪烁的城市里，两个陌生人的偶然相遇，点亮了彼此最灰暗的那段日子。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20poster%2C%20two%20people%20silhouette%20on%20a%20rooftop%20overlooking%20a%20glowing%20city%20skyline%20at%20dusk%2C%20warm%20orange%20and%20teal%20tones%2C%20emotional%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d5-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20city%20skyline%20at%20blue%20hour%20with%20glowing%20windows%20and%20warm%20street%20lights%2C%20romantic%20dreamy%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d5-backdrop&orientation=landscape",
    tags: [],
    featured: true,
  },
  {
    id: "d6",
    title: "末路狂飙",
    typeLabel: "电影",
    genres: ["动作", "犯罪"],
    region: "美国",
    year: 2026,
    rating: 7.6,
    views: 760,
    duration: "109分钟",
    director: "马克·维加",
    actors: ["德里克·兰", "索菲亚·雷"],
    synopsis: "一场横跨三座城市的高速追捕，退役车手被迫重出江湖，只为救回最重要的人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%2C%20sports%20car%20drifting%20through%20a%20neon%20lit%20city%20at%20night%2C%20motion%20blur%2C%20orange%20light%20trails%2C%20high%20energy%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d6-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20highway%20chase%20at%20night%20with%20glowing%20tail%20lights%20and%20city%20skyline%2C%20fast%20motion%20energy%2C%20warm%20orange%20glow%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d6-backdrop&orientation=landscape",
    tags: [],
  },
  {
    id: "d7",
    title: "雪国列车之夜",
    typeLabel: "电影",
    genres: ["悬疑", "惊悚"],
    region: "韩国",
    year: 2025,
    rating: 8.0,
    views: 690,
    duration: "125分钟",
    director: "朴成勋",
    actors: ["金秀焕", "尹雅琳"],
    synopsis: "一列驶向北方的夜行列车遭遇暴雪停驶，乘客中隐藏的秘密随着车厢逐一被揭开。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20poster%2C%20vintage%20train%20window%20covered%20in%20snow%20at%20night%2C%20dim%20warm%20interior%20light%2C%20tense%20cold%20blue%20tones%2C%20moody%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d7-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20night%20train%20crossing%20a%20snowy%20landscape%2C%20warm%20window%20lights%20against%20cold%20blue%20snow%2C%20moody%20mysterious%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d7-backdrop&orientation=landscape",
    tags: [],
  },
  {
    id: "d8",
    title: "飞鸟与蝉",
    typeLabel: "电影",
    genres: ["爱情", "青春"],
    region: "日本",
    year: 2024,
    rating: 8.2,
    views: 540,
    duration: "116分钟",
    director: "小林遥",
    actors: ["佐藤悠", "中村葵"],
    synopsis: "一个关于夏日、蝉鸣与错过告别的青春故事，年少的心事在时光里慢慢发酵。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20youth%20romance%20poster%2C%20two%20students%20under%20a%20sunlit%20tree%20in%20summer%2C%20warm%20golden%20light%20and%20gentle%20green%20tones%2C%20nostalgic%20soft%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d8-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20sunlit%20japanese%20school%20path%20in%20summer%20with%20green%20trees%20and%20warm%20golden%20backlight%2C%20nostalgic%20youthful%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d8-backdrop&orientation=landscape",
    tags: [],
  },
  {
    id: "d9",
    title: "沙海纪元",
    typeLabel: "电影",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2026,
    rating: 8.5,
    views: 1340,
    duration: "156分钟",
    director: "伊桑·布莱克",
    actors: ["诺亚·格兰特", "莉亚·康"],
    synopsis: "在资源枯竭的沙海星球，一支探险队循着古老遗迹寻找传说中的水源，改变整个文明命运。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20epic%20sci-fi%20poster%2C%20lone%20figure%20in%20a%20cloak%20walking%20across%20vast%20orange%20desert%20dunes%20under%20a%20huge%20sun%2C%20dramatic%20scale%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d9-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20epic%20desert%20planet%20landscape%20with%20towering%20dunes%20and%20twin%20suns%2C%20warm%20orange%20haze%2C%20grand%20sci-fi%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d9-backdrop&orientation=landscape",
    tags: [],
  },
  {
    id: "d10",
    title: "迷雾侦探",
    typeLabel: "电影",
    genres: ["悬疑", "推理"],
    region: "中国大陆",
    year: 2025,
    rating: 7.8,
    views: 620,
    duration: "112分钟",
    director: "沈知白",
    actors: ["陆行舟", "许清欢"],
    synopsis: "大雾笼罩的小镇接连发生离奇案件，一位退隐的心理侧写师被迫重返案发现场。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20detective%20poster%2C%20figure%20holding%20a%20flashlight%20in%20thick%20fog%20on%20a%20quiet%20street%2C%20muted%20cold%20tones%20with%20amber%20beam%2C%20tense%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d10-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20fog%20covered%20old%20town%20street%20at%20dusk%20with%20dim%20street%20lamps%2C%20mysterious%20muted%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d10-backdrop&orientation=landscape",
    tags: [],
  },
  {
    id: "d11",
    title: "镜中城",
    typeLabel: "电视剧",
    genres: ["悬疑", "奇幻"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    views: 1450,
    duration: "更新至18集",
    director: "林澈",
    actors: ["顾南风", "沈知夏", "周亦然"],
    synopsis: "一座与现实互为镜像的城市悄然出现，年轻的建筑师发现自己的倒影正在替她生活。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20mystery%20poster%2C%20city%20reflected%20in%20a%20giant%20cracked%20mirror%2C%20surreal%20dark%20blue%20and%20violet%20tones%2C%20glowing%20window%20lights%2C%20eerie%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d11-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20surreal%20mirror%20city%20at%20night%20with%20reflected%20glowing%20skyscrapers%2C%20cool%20blue%20and%20indigo%20atmosphere%2C%20mesmerizing%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d11-backdrop&orientation=landscape",
    episodes: 18,
    tags: [],
    featured: true,
  },
  {
    id: "d12",
    title: "东京迷情",
    typeLabel: "电视剧",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2024,
    rating: 8.0,
    views: 780,
    duration: "全12集",
    director: "山田健",
    actors: ["高桥凉介", "石原结衣"],
    synopsis: "在东京最繁忙的街区，一段关于梦想、漂泊与重逢的都市情感故事缓缓展开。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20drama%20poster%2C%20couple%20standing%20under%20a%20glowing%20street%20lamp%20in%20rainy%20tokyo%20alley%2C%20warm%20amber%20light%20and%20cool%20blue%2C%20romantic%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d12-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20tokyo%20neon%20street%20at%20night%20with%20rain%20and%20bokeh%20lights%2C%20romantic%20urban%20mood%2C%20warm%20and%20cool%20contrast%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d12-backdrop&orientation=landscape",
    episodes: 12,
    tags: [],
  },
  {
    id: "d13",
    title: "王座之影",
    typeLabel: "电视剧",
    genres: ["奇幻", "权谋"],
    region: "英国",
    year: 2025,
    rating: 9.0,
    views: 1620,
    duration: "更新至9集",
    director: "詹姆斯·福斯特",
    actors: ["艾登·克莱尔", "薇拉·诺曼"],
    synopsis: "七大王国为争夺王座明争暗斗，一位被流放的继承人带着秘密军团踏上归途。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20epic%20fantasy%20poster%2C%20armored%20warrior%20with%20cloak%20standing%20before%20a%20dark%20castle%2C%20dramatic%20torchlight%2C%20cold%20grey%20and%20amber%20tones%2C%20grand%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d13-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20epic%20fantasy%20landscape%20with%20a%20massive%20stormy%20castle%20on%20a%20cliff%2C%20moody%20grey%20skies%20and%20torch%20lights%2C%20grand%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d13-backdrop&orientation=landscape",
    episodes: 9,
    tags: [],
  },
  {
    id: "d14",
    title: "急诊风云",
    typeLabel: "电视剧",
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    views: 1190,
    duration: "全36集",
    director: "谢明",
    actors: ["郑立", "苏晴", "方远"],
    synopsis: "急诊室的每一分钟都在与时间赛跑，一群年轻医生在生死之间坚守初心。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%2C%20doctor%20in%20scrubs%20under%20bright%20hospital%20lights%2C%20cool%20teal%20and%20white%20tones%20with%20warm%20accents%2C%20tense%20hopeful%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d14-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20modern%20hospital%20corridor%20with%20cool%20teal%20lighting%20and%20blurred%20medical%20staff%2C%20clinical%20calm%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d14-backdrop&orientation=landscape",
    episodes: 36,
    tags: [],
  },
  {
    id: "d15",
    title: "汉江往事",
    typeLabel: "电视剧",
    genres: ["犯罪", "剧情"],
    region: "韩国",
    year: 2026,
    rating: 8.7,
    views: 1020,
    duration: "更新至14集",
    director: "崔民浩",
    actors: ["姜东元", "李瑞妍"],
    synopsis: "横跨二十年的黑帮恩怨在汉江两岸上演，一个家族的秘密与背叛牵连着整座城市。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20korean%20crime%20drama%20poster%2C%20man%20in%20dark%20suit%20standing%20by%20a%20river%20bridge%20at%20night%2C%20moody%20neon%20reflections%2C%20cold%20and%20amber%20tones%2C%20tense%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d15-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20night%20view%20of%20a%20bridge%20over%20a%20city%20river%20with%20glowing%20lights%2C%20moody%20crime%20drama%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d15-backdrop&orientation=landscape",
    episodes: 14,
    tags: [],
  },
  {
    id: "d16",
    title: "硅谷幻梦",
    typeLabel: "电视剧",
    genres: ["剧情", "喜剧"],
    region: "美国",
    year: 2025,
    rating: 8.1,
    views: 640,
    duration: "全10集",
    director: "内森·科尔",
    actors: ["杰克·罗", "米娅·陈"],
    synopsis: "一群年轻创业者在硅谷追逐梦想，代码、资本与友情在现实面前接受考验。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20tech%20drama%20poster%2C%20young%20founder%20in%20a%20modern%20office%20lit%20by%20monitor%20glow%20at%20night%2C%20cool%20blue%20tones%20with%20warm%20accent%2C%20ambitious%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d16-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20modern%20startup%20office%20at%20night%20with%20glowing%20screens%20and%20city%20view%2C%20cool%20blue%20tones%2C%20energetic%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d16-backdrop&orientation=landscape",
    episodes: 10,
    tags: [],
  },
  {
    id: "d17",
    title: "山海秘境",
    typeLabel: "电视剧",
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    views: 1130,
    duration: "更新至22集",
    director: "白鹿原",
    actors: ["顾星野", "云深", "姜黎"],
    synopsis: "少年无意间打开山海图卷，与伙伴踏入神兽栖息的秘境，展开一场跨越山海的奇幻冒险。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20fantasy%20poster%2C%20young%20hero%20before%20a%20giant%20mythical%20beast%20in%20a%20misty%20mountain%20valley%2C%20vivid%20colors%2C%20epic%20adventure%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=400&height=600&seq=pp-d17-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=anime%20style%20epic%20fantasy%20landscape%20with%20floating%20mountains%20and%20mythical%20creatures%2C%20vivid%20colorful%20atmosphere%2C%20whimsical%20adventure%20mood%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d17-backdrop&orientation=landscape",
    episodes: 22,
    tags: ["动漫"],
  },
  {
    id: "d18",
    title: "北境烽火",
    typeLabel: "电视剧",
    genres: ["战争", "历史"],
    region: "中国大陆",
    year: 2024,
    rating: 8.5,
    views: 900,
    duration: "全40集",
    director: "岳崇山",
    actors: ["楚天阔", "韩雪", "赵牧"],
    synopsis: "烽火连天的北境边关，一支孤军以血肉之躯守护家园，谱写了一曲家国壮歌。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20war%20epic%20poster%2C%20soldier%20silhouette%20on%20a%20fortress%20wall%20against%20a%20burning%20orange%20sky%2C%20dramatic%20smoke%20and%20embers%2C%20grim%20heroic%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=pp-d18-cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20fortress%20on%20a%20snowy%20border%20under%20a%20dramatic%20sunset%20sky%2C%20epic%20historical%20war%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=pp-d18-backdrop&orientation=landscape",
    episodes: 40,
    tags: [],
  },
];

export const featuredMovies: Movie[] = movies.filter((m) => m.featured);

export const latestMovies: Movie[] = [...movies].sort((a, b) => Number(b.year) - Number(a.year) || b.rating - a.rating);

export const hotMovies: Movie[] = [...movies].sort((a, b) => b.views - a.views || b.rating - a.rating);